import type { ProcessSequenceStep } from '@/types/process';

export const STAGE_COLORS = [
  '#ff7a45',
  '#e74c3c',
  '#2ecc71',
  '#9b59b6',
  '#3498db',
  '#f39c12',
] as const;

/** Stage videos in /public/images */
const PROCESS_VIDEO_FILES = [
  'Step 1_Limestone Mining.mp4',
  'Step_2_Limestonecrushing.mp4',
  'Step3_Limestone Grinding.mp4',
  'Step4_Pre-HeatingPre-Calciner Clinkerization.mp4',
  'Step5_Cement Grinding.mp4',
  'Step6_Cement Packing.mp4',
] as const;

export function getStageVideoSrc(stageId: number): string {
  const index = stageId - 1;
  const file = PROCESS_VIDEO_FILES[index] ?? PROCESS_VIDEO_FILES[0];
  return `/images/${encodeURI(file)}`;
}

export interface ProcessStageStat {
  label: string;
  value: string;
}

export interface ProcessStageView {
  id: number;
  sectionId: string;
  stepNumber: string;
  title: string;
  subtitle: string;
  color: string;
  shortDesc: string;
  detailDesc: string;
  stats: ProcessStageStat[];
  videoSrc: string;
  imageUrl?: string | null;
  buttonText?: string | null;
}

export const FALLBACK_STAGE_STATS: ProcessStageStat[][] = [
  [
    { label: 'Truck Capacity', value: '55–60T' },
    { label: 'Loader Volume', value: '10m³' },
    { label: 'Technology', value: 'NONEL' },
  ],
  [
    { label: 'Input Size', value: '>50mm' },
    { label: 'Output Size', value: '<75mm' },
    { label: 'Reject Size', value: '<10mm' },
  ],
  [
    { label: 'Mill Origin', value: 'Germany' },
    { label: 'Rollers', value: '3×' },
    { label: 'Supplier', value: 'Pfeiffer' },
  ],
  [
    { label: 'Kiln Length', value: '75m' },
    { label: 'Temperature', value: '1450°C' },
    { label: 'Residence', value: '15 min' },
  ],
  [
    { label: 'Gypsum Mix', value: '4–6%' },
    { label: 'Steel Balls', value: '155T' },
    { label: 'Ball Mills', value: '2×' },
  ],
  [
    { label: 'Storage Silos', value: '4×' },
    { label: 'Roto Packers', value: '8×' },
    { label: 'QC System', value: 'POLAB' },
  ],
];

export function getStageStats(index: number): ProcessStageStat[] {
  return FALLBACK_STAGE_STATS[index] ?? FALLBACK_STAGE_STATS[0];
}

/** @deprecated Use getStageStats — CMS detail items belong in modal copy, not the stats grid */
export function buildStatsFromStep(_step: ProcessSequenceStep, index: number): ProcessStageStat[] {
  return getStageStats(index);
}
